import { App } from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue'

export default {
  install(app: App<Element>) {
    app.use(CKEditor)
  }
}
